import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule } from 'lucide-angular';
import { NgApexchartsModule } from 'ng-apexcharts';
import { RouterOutlet, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzDropdownModule } from 'ng-zorro-antd/dropdown';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { AuthService } from 'auth';

@Component({
  selector: 'app-side-bar',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule,
    NgApexchartsModule,
    FormsModule,
    ReactiveFormsModule,
    NzIconModule,
    NzInputModule,
    NzSpaceModule,
    NzDropdownModule,
    NzModalModule,
    NzModalModule,
    RouterOutlet,
    NgApexchartsModule,
    RouterModule,
  ],
  templateUrl: './side-bar.html',
  styleUrl: './side-bar.scss',
})
export class SideBar implements OnInit {
  currentDate = new Date();
  userName = '';
  userInitials = '';

  constructor(private authService: AuthService) { }

  ngOnInit() {
    this.loadUserProfile();
  }

  get userRole(): string {
    const userInfo: any = this.authService.accessTokenInfo();
    let role = userInfo?.role || userInfo?.['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] || 'Super Admin';
    if (Array.isArray(role)) {
      role = role[0];
    }
    return role;
  }

  loadUserProfile() {
    const userId = this.authService.getUserId();
    if (userId) {
      this.authService.getUserById(userId).subscribe({
        next: (res: any) => {
          const user = res?.data || res;
          if (user && user.fullName) {
            this.userName = user.fullName;
            this.userInitials = this.getInitials(user.fullName);
          }
        },
        error: (err) => {
          console.error('Error fetching user profile:', err);
        }
      });
    }
  }

  private getInitials(name: string): string {
    if (!name || name === 'User') return 'SA';
    const parts = name.trim().split(/\s+/);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return parts[0][0]?.toUpperCase() || 'SA';
  }

  isLoading = false;

  isOpen = false;

  isLogoutModalVisible = false;

  logout() {
    this.isLogoutModalVisible = true;
  }

  confirmLogout() {
    this.isLogoutModalVisible = false;
    this.authService.logout();
  }

  openModal() {
    this.isOpen = true;
  }

  closeModal() {
    this.isOpen = false;
  }
}
